export default __webpack_public_path__ + "static/media/india_icon.6d15360f.png";